// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pagination-wrapper[data-v-589ea6d8]{letter-spacing:.5rem;list-style:none}a[data-v-589ea6d8]{color:#6c757d}.active[data-v-589ea6d8]{color:#000}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
